@if (_report) {
  <p>
    <a href="{{embed}}"  target="_blank">{{_report.displayName}}</a>
  </p>
}


